
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Dialog from '../common/Dialog';
import DialogContainer from '../common/DialogContainer';
import IfComp from '../common/IfComp';

import MapState from './Map.state';

const classNames = mergeStyleSets({
    root: {
        padding: 16
    },
    title: {
        paddingBottom: 16
    },
    content: {
        paddingRight: 8,
        marginBottom: 8,
        width: 1000,
        height: 700
    },
    closeIcon: {
    }
});

const MapContent = ({parItem}) => {
    return (
        <MapState
            parItem={parItem}
        />
    )
}

const MapDialog = ({open, onDismiss, parItem}) => {

    return (
        <Dialog
            open={open}
            onDismiss={onDismiss}
            title="Mapa"
            buttons={[]}
        >
            <Stack className={classNames.root}>
                <Stack.Item className={classNames.content}>
                    <IfComp cond={!!parItem}>
                        <MapContent parItem={parItem} />
                    </IfComp>
                </Stack.Item>
            </Stack>
        </Dialog>
    );
}

class MapDialogContainer extends DialogContainer {
    static resolve = null;
    static instance = null;

    static create() {
        MapDialogContainer.instance = DialogContainer.create(
            MapDialogContainer.instance,
            MapDialogContainer
        );
        return MapDialogContainer.instance;
    }

    constructor(props) {
        super(props, {parItem: null});
    }

    getResolve() {
        return MapDialogContainer.resolve;
    }

    open(parItem) {
        return super.open({parItem});
    }

    renderContent() {
        let props = {
            parItem: this.state.parItem,
            ...this.getDialogProps()
        }
        return (
            <MapDialog
                {...props}
            />
        );
    }

    setResolve(res) {
        MapDialogContainer.resolve = res;
    }

}

export default MapDialogContainer.create;
